<template>
    <form v-on:submit.prevent="submit">
        <div class="form-group" :class="{ 'form-group--error': $v.courtesyContact.$error }">
            <div class="card mb-3" header-bg-variant="primary" header-text-variant="white">
                <h2 class="card-header">Courtesy Contact 1 (optional)</h2>
                <div class="card-body">
                    <p>Review courtesy contact.</p>

                    <div class="form-row">
                        <div class="col-md-8"  style="padding-bottom: 10px;">
                            <div class="form-group ">
                                <label for="selectypeCourtesy1" style="color: #0062cc">Select an action for this contact and then press proceed:&nbsp; </label>
                            <select v-model="selectedEditCC1" v-on:change="changeCC1(this.selectedEditCC1)"
                                    id="selectypeCourtesy1"
                                    size="4"
                                    style="width: 500px;">
                                <option value="1" >No changes</option>
                                <option value="2" >Edit {{(courtesyContact.prepareNamef !== '' || courtesyContact.prepareNamel !== '') ? courtesyContact.prepareNamef + " " + courtesyContact.prepareNamel : "new contact"}}</option>
                                <option value="3" >Search for a different courtesy contact</option>
                                <option value="4" >Add a new courtesy contact</option>
                            </select> <p/>
                            <b-button aria-colspan="2" variant="primary" v-on:click="changeCC1(selectedEditCC1)">Proceed</b-button>
                            </div>
                        </div>
                    </div>
                    <b-modal id="modal-search-courtesy-contact" size="lg" hide-header hide-footer scrollable >
                          <h2>Search Contacts</h2>
                          <hr/>
                          <form ref="form" @submit.prevent="save">
                            <div v-show="'preparer'=== 'preparer'">
                              <b-row>
                                <b-col cols="12">
                                  <EmailSearch :original-contact="courtesyContact" @enable="enableCC1" v-model="courtesyContact"
                                    :v="$v.courtesyContact"/>
                                </b-col>
                              </b-row>
                            </div>

                              <b-row style="padding-top: 10px;">
                                <b-col>
                                  <b-button @click="close" style="margin-right:15px;">Close</b-button>
                                </b-col>
                              </b-row>
                          </form>
                    </b-modal>
                    <b-row>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareNamef">Courtesy contact first name:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareNamef" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareNamef.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareNamef)}"
                                              aria-label="Courtesy contact first name">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareNamef.required" class="invalid-feedback">Courtesy contact first name is required</div>
                                <div v-if="!$v.courtesyContact.prepareNamef.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareNamel">Courtesy contact last name:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareNamel" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareNamel.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareNamel)}"
                                              aria-label="Courtesy contact last name">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareNamel.required" class="invalid-feedback">Courtesy contact last name is required</div>
                                <div v-if="!$v.courtesyContact.prepareNamel.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-title">Courtesy contact title:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-title" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.title.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.title)}"
                                              aria-label="Courtesy contact title">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.title.required" class="invalid-feedback">Courtesy contact title is required</div>
                                <div v-if="!$v.courtesyContact.title.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareorgName">Courtesy contact organization name:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareorgName" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareorgName.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareorgName)}"
                                              aria-label="Courtesy contact organization name">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareorgName.required" class="invalid-feedback">Courtesy contact organization name is required</div>
                                <div v-if="!$v.courtesyContact.prepareorgName.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                    </b-row>

                    <b-row>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareEmail">Courtesy contact email:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareEmail" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareEmail.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareEmail)}"
                                              aria-label="Courtesy contact email">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareEmail.required" class="invalid-feedback">Courtesy contact email is required</div>
                                <div v-if="!$v.courtesyContact.prepareEmail.email" class="invalid-feedback">Courtesy contact email must be a valid email address</div>
                                <div v-if="!$v.courtesyContact.prepareEmail.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-preparePhone">Courtesy contact phone number:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-preparePhone" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.preparePhone.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.preparePhone)}"
                                              aria-label="Courtesy contact phone number"
                                              v-mask="'###-###-####'">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.preparePhone.required" class="invalid-feedback">Courtesy contact phone number is required</div>
                                <div v-if="!$v.courtesyContact.preparePhone.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-phoneExt">Courtesy contact phone extension:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-phoneExt" type="text" class="form-control form-control-lg"
                                              aria-label="Courtesy contact phone extension"
                                              v-mask="'###-###-####'">
                                </b-form-input>

                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareFax">Courtesy contact fax number:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareFax" type="text" class="form-control form-control-lg"
                                              aria-label="Courtesy contact fax number"
                                              v-mask="'###-###-####'">
                                </b-form-input>
                            </div>
                        </b-col>

                    </b-row>

                    <b-row>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareAddress">Courtesy contact address:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareAddress" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareAddress.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareAddress)}"
                                              aria-label="Courtesy contact address">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareAddress.required" class="invalid-feedback">Courtesy contact address is required</div>
                                <div v-if="!$v.courtesyContact.prepareAddress.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareCity">Courtesy contact city:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareCity" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareCity.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareCity)}"
                                              aria-label="Courtesy contact city">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareCity.required" class="invalid-feedback">Courtesy contact city is required</div>
                                <div v-if="!$v.courtesyContact.prepareCity.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareCounty">Courtesy contact county:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareCounty" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareCounty.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareCounty)}"
                                              aria-label="Courtesy contact county">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareCounty.required" class="invalid-feedback">Courtesy contact county is required</div>
                                <div v-if="!$v.courtesyContact.prepareCounty.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareState">Courtesy contact state:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareState" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareState.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareState)}"
                                              aria-label="Courtesy contact state">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareState.required" class="invalid-feedback">Courtesy contact state is required</div>
                                <div v-if="!$v.courtesyContact.prepareState.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact-prepareZip">Courtesy contact zip code:</label>
                                <b-form-input :disabled="keepDisabledCC1" id="courtesyContact-prepareZip" type="text" v-mask="'#####-####'" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact.prepareZip.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact.prepareZip)}"
                                              aria-label="Courtesy contact zip code">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact.prepareZip.required" class="invalid-feedback">Courtesy contact zip code is required</div>
                                <div v-if="!$v.courtesyContact.prepareZip.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                    </b-row>

                </div>
            </div>
        </div>

        <button @click="toggleShowCC2()" class="btn btn-outline-primary col-lg-3 col-sm-6">{{showCC2 ? 'Remove second courtesy contact' : 'Add another courtesy contact (optional)'}}</button>
        <br><br>

        <div v-show="showCC2" class="form-group" :class="{ 'form-group--error': $v.courtesyContact2.$error }">
            <div class="card mb-3" header-bg-variant="primary" header-text-variant="white">
                <h2 class="card-header">Courtesy Contact 2 (optional)</h2>
                <div class="card-body">
                    <p>Review courtesy contact.</p>
                    <div class="form-row">
                        <div class="col-md-8"  style="padding-bottom: 10px;">
                            <div class="form-group">
                                <label for="selectypeCourtesy2" style="color: #0062cc">Select an action for this contact and then press proceed:&nbsp; </label>
                            <select v-model="selectedEditCC2" v-on:change="changeCC2(this.selectedEditCC2)"
                                    id="selectypeCourtesy2"
                                    size="4"
                                    style="width: 500px;">
                                <option value="1" >No changes</option>
                                <option value="2" >Edit {{(courtesyContact2.prepareNamef !== '' || courtesyContact2.prepareNamel !== '') ? courtesyContact2.prepareNamef + " " + courtesyContact2.prepareNamel : "new contact"}}</option>
                                <option value="3" >Search for a different courtesy contact</option>
                                <option value="4" >Add a new courtesy contact</option>
                            </select> <p/>
                            <b-button aria-colspan="2" variant="primary" v-on:click="changeCC2(selectedEditCC2)">Proceed</b-button>
                            </div>
                        </div>
                    </div>
                    <b-modal id="modal-search-courtesy-contact-2" size="lg" hide-header hide-footer scrollable >
                          <h2>Search Contacts</h2>
                          <hr/>
                          <form ref="form" @submit.prevent="save">
                            <div v-show="'preparer'=== 'preparer'">
                              <b-row>
                                <b-col cols="12">
                                  <EmailSearch :original-contact="courtesyContact2" @enable="enableCC2" v-model="courtesyContact2"
                                    :v="$v.courtesyContact2"/>
                                </b-col>
                              </b-row>
                            </div>

                              <b-row style="padding-top: 10px;">
                                <b-col>
                                  <b-button @click="close" style="margin-right:15px;">Close</b-button>
                                </b-col>
                              </b-row>
                          </form>
                    </b-modal>
                    <b-row>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareNamef">Courtesy contact first name:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareNamef" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareNamef.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareNamef)}"
                                              aria-label="Courtesy contact first name">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareNamef.required" class="invalid-feedback">Courtesy contact first name is required</div>
                                <div v-if="!$v.courtesyContact2.prepareNamef.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareNamel">Courtesy contact last name:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareNamel" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareNamel.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareNamel)}"
                                              aria-label="Courtesy contact last name">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareNamel.required" class="invalid-feedback">Courtesy contact last name is required</div>
                                <div v-if="!$v.courtesyContact2.prepareNamel.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-title">Courtesy contact title:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-title" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.title.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.title)}"
                                              aria-label="Courtesy contact title">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.title.required" class="invalid-feedback">Courtesy contact title is required</div>
                                <div v-if="!$v.courtesyContact2.title.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareorgName">Courtesy contact organization name:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareorgName" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareorgName.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareorgName)}"
                                              aria-label="Courtesy contact organization name">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareorgName.required" class="invalid-feedback">Courtesy contact organization name is required</div>
                                <div v-if="!$v.courtesyContact2.prepareorgName.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                    </b-row>

                    <b-row>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareEmail">Courtesy contact email:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareEmail" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareEmail.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareEmail)}"
                                              aria-label="Courtesy contact email">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareEmail.required" class="invalid-feedback">Courtesy contact email is required</div>
                                <div v-if="!$v.courtesyContact2.prepareEmail.email" class="invalid-feedback">Courtesy contact email must be a valid email address</div>
                                <div v-if="!$v.courtesyContact2.prepareEmail.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-preparePhone">Courtesy contact phone number:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-preparePhone" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.preparePhone.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.preparePhone)}"
                                              aria-label="Courtesy contact phone number"
                                              v-mask="'###-###-####'">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.preparePhone.required" class="invalid-feedback">Courtesy contact phone number is required</div>
                                <div v-if="!$v.courtesyContact2.preparePhone.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-phoneExt">Courtesy contact phone extension:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-phoneExt" type="text" class="form-control form-control-lg"
                                              aria-label="Courtesy contact phone extension"
                                              v-mask="'###-###-####'">
                                </b-form-input>

                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareFax">Courtesy contact fax number:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareFax" type="text" class="form-control form-control-lg"
                                              aria-label="Courtesy contact fax number"
                                              v-mask="'###-###-####'">
                                </b-form-input>

                            </div>
                        </b-col>

                    </b-row>

                    <b-row>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareAddress">Courtesy contact address:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareAddress" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareAddress.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareAddress)}"
                                              aria-label="Courtesy contact address">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareAddress.required" class="invalid-feedback">Courtesy contact address is required</div>
                                <div v-if="!$v.courtesyContact2.prepareAddress.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareCity">Courtesy contact city:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareCity" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareCity.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareCity)}"
                                              aria-label="Courtesy contact city">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareCity.required" class="invalid-feedback">Courtesy contact city is required</div>
                                <div v-if="!$v.courtesyContact2.prepareCity.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareCounty">Courtesy contact county:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareCounty" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareCounty.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareCounty)}"
                                              aria-label="Courtesy contact county">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareCounty.required" class="invalid-feedback">Courtesy contact county is required</div>
                                <div v-if="!$v.courtesyContact2.prepareCounty.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>
                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareState">Courtesy contact state:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareState" type="text" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareState.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareState)}"
                                              aria-label="Courtesy contact state">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareState.required" class="invalid-feedback">Courtesy contact state is required</div>
                                <div v-if="!$v.courtesyContact2.prepareState.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                        <b-col cols="12" xl="6" lg="6" md="6">
                            <div class="form-group">
                                <label for="courtesyContact2-prepareZip">Courtesy contact zip code:</label>
                                <b-form-input :disabled="keepDisabledCC2" id="courtesyContact2-prepareZip" type="text" v-mask="'#####-####'" class="form-control form-control-lg"
                                              v-model.trim="$v.courtesyContact2.prepareZip.$model"
                                              :class="{'is-invalid': validationStatus($v.courtesyContact2.prepareZip)}"
                                              aria-label="Courtesy contact zip code">
                                </b-form-input>
                                <div v-if="!$v.courtesyContact2.prepareZip.required" class="invalid-feedback">Courtesy contact zip code is required</div>
                                <div v-if="!$v.courtesyContact2.prepareZip.minLength" class="invalid-feedback">Text needs to be entered</div>
                            </div>
                        </b-col>

                    </b-row>
                </div>
            </div>
        </div>

        <!-- <button to="dropzone" class="btn btn-outline-primary col-lg-3 col-sm-6">Continue</button> -->
    </form>
</template>

<script>

    import { required, minLength, email, maxLength, requiredIf } from 'vuelidate/lib/validators'
    import EmailSearch from '@/components/EmailSearch'
    import lambdaURL from '../lambda'

    export default {
    components: {
        EmailSearch
    },
    mounted() {
        lambdaURL.getCourtesyContacts(this.$route.params.id, this.$keycloak.userName).then((res) => {
            Object.assign(this.$data.courtesyContact, res[0]);
            Object.assign(this.$data.courtesyContact2, res[1]);
            })
            .catch((err) => {
            })
    },

        data: function() {
            return {
                courtesyContact: {
                    prepareNamef: '',
                    prepareNamel: '',
                    title: '',
                    prepareorgName: '',
                    prepareEmail: '',
                    preparePhone: '',
                    phoneExt: '',
                    prepareFax: '',
                    prepareAddress: '',
                    prepareCity: '',
                    prepareCounty: '',
                    prepareState: '',
                    prepareZip: '',
                    //contactTypeId: 32,
                    sourceTypeId: 86
                },
                courtesyContact2: {
                    prepareNamef: '',
                    prepareNamel: '',
                    title: '',
                    prepareorgName: '',
                    prepareEmail: '',
                    preparePhone: '',
                    phoneExt: '',
                    prepareFax: '',
                    prepareAddress: '',
                    prepareCity: '',
                    prepareCounty: '',
                    prepareState: '',
                    prepareZip: '',
                    //contactTypeId: 32,
                    sourceTypeId: 86
                },
                showCC2: false,
                selectedEditCC1: '',
                selectedEditCC2: '',
                defaultEdit: 'Please select contact action',
                keepDisabledCC1: true,
                keepDisabledCC2: true
            }
        },
        validations: {
            courtesyContact: {
                prepareNamef: {required:false, minLength: minLength(1), maxLength: maxLength(100)},
                prepareNamel: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
                title: {required:false, minLength: minLength(1), maxLength: maxLength(100)},
                prepareorgName: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
                prepareEmail: {required: false, email, minLength: minLength(1), maxLength: maxLength(100)},
                preparePhone: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
                prepareAddress: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
                prepareCity: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
                prepareCounty: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
                prepareState: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
                prepareZip: {required: false, minLength: minLength(1), maxLength: maxLength(100)},
                sourceTypeId: {required: false}
            },
            courtesyContact2: {
                prepareNamef: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                prepareNamel: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                title: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                prepareorgName: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                prepareEmail: {required: requiredIf(function() { return this.showCC2 === true }), email, minLength: minLength(1), maxLength: maxLength(100)},
                preparePhone: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                prepareAddress: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                prepareCity: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                prepareCounty: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                prepareState: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                prepareZip: {required: requiredIf(function() { return this.showCC2 === true }), minLength: minLength(1), maxLength: maxLength(100)},
                sourceTypeId: {required: false}
            },
            form: ['courtesyContact', 'courtesyContact2'],
        },
        methods: {

            enableCC1: function (value) {
                this.keepDisabledCC1 = value;
            },

            enableCC2: function (value) {
                this.keepDisabledCC2 = value;
            },

            validate() {
                this.$v.form.$touch();
                var isValid = !this.$v.form.$invalid
                this.$emit('on-validate', this.$data, isValid)
                return isValid
            },

            validationStatus: function(validation) {
                return typeof validation != "undefined" ? validation.$error : false;
            },

            submit: function() {

                this.$v.$touch();
                if (this.$v.$pendding || this.$v.$error) return;

                //window.location.replace('/dropzone');
            },

            toggleShowCC2(){
                this.showCC2 = !this.showCC2
            },

            changeCC1: function (args) {
                if (args === '1') {
                    this.keepDisabledCC1 = true;
                    this.validate();
                    //this.$parent.refs.wizard.nextTab();
                    //window.location.replace('/dropzone');
                    //viewText = 'Click next to proceed.'
                }
                if (args === '2') {
                    this.keepDisabledCC1 = false;
                }
                if (args === '3' || args === '4') {
                    this.$bvModal.show('modal-search-courtesy-contact')
                    //window.location.replace('/emailsearch');
                }
            },

            changeCC2: function (args) {
                if (args === '1') {
                    this.keepDisabledCC2 = true;
                    this.validate();
                    //this.$parent.refs.wizard.nextTab();
                    //window.location.replace('/dropzone');
                    //viewText = 'Click next to proceed.'
                }
                if (args === '2') {
                    this.keepDisabledCC2 = false;
                }
                if (args === '3' || args === '4') {
                    this.$bvModal.show('modal-search-courtesy-contact-2')
                    //window.location.replace('/emailsearch');
                }
            },

            close () {
                this.$bvModal.hide('modal-search-courtesy-contact')
                this.$bvModal.hide('modal-search-courtesy-contact-2')
                setTimeout(() => {
                    /**this.school = Object.assign({}, this.defaultItem)
                    this.k12Obj =  {}
                    this.campusActivitySelection = [ ]
                    this.editedIndex = -1
                    this.$nextTick(() => { this.$v.school.$reset() })**/
                }, 300)
            },
        }

    }

</script>

<style>

</style>
